import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
export const ColumnsContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => props?.templateColumns || '1fr'};
  gap: ${props => props.theme.spacing.sp16};

  @media (max-width: 1120px) {
    grid-template-columns: 1fr;
  }
`
